module.exports = __webpack_public_path__ + "static/media/1.ready.016ee167.jpg";